import React from 'react'
import { useRouteError } from 'react-router-dom'

// Tela que aparece quando um erro escapa do render de qualquer rota.
//
// Sem ela, quem via a falha era o error boundary embutido do React Router: um
// "Unexpected Application Error!" em inglês com o stack trace cru na cara do
// cliente. Além de assustar, não dizia o que fazer — e o cliente ficava preso
// numa tela morta, porque nada ali oferece um caminho de volta.
//
// De propósito esta tela não usa o tema do MUI nem os contextos do painel: ela
// precisa desenhar mesmo quando o erro veio justamente de um deles.
export default function ErrorPage() {
  const erro = useRouteError()
  const detalhe = erro instanceof Error ? `${erro.message}\n\n${erro.stack || ''}` : String(erro)

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-white text-gray-900 dark:bg-[#161d25] dark:text-gray-100">
      <div className="w-full max-w-[520px] text-center">
        <h1 className="text-2xl font-black">Algo deu errado nesta tela</h1>

        <p className="mt-3 text-sm opacity-80">
          A página parou no meio do caminho. Nenhuma mensagem foi perdida: o que estava
          na fila continua sendo enviado normalmente.
        </p>

        <p className="mt-2 text-sm opacity-80">
          Recarregar costuma resolver. Se o navegador estiver traduzindo o painel
          automaticamente, desligue a tradução desta página — ela reescreve a tela por
          baixo e derruba o painel.
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-md px-4 py-2 text-sm font-bold text-white"
            style={{ backgroundColor: '#00ccff' }}
          >
            Recarregar a página
          </button>

          {/* Link comum, e não navegação do router: se o erro deixou o router num
              estado ruim, uma troca de rota interna cairia no mesmo lugar. */}
          <a
            href="/"
            className="rounded-md border border-gray-400/40 px-4 py-2 text-sm font-bold"
          >
            Voltar ao início
          </a>
        </div>

        {/* O detalhe técnico continua acessível para o suporte, mas fechado: é
            informação para nós, não para quem só queria ver o relatório. */}
        <details className="mt-8 text-left">
          <summary className="cursor-pointer text-xs opacity-60">Detalhe técnico</summary>
          <pre className="mt-2 max-h-[240px] overflow-auto rounded bg-gray-500/10 p-3 text-[11px] whitespace-pre-wrap break-words">
            {detalhe}
          </pre>
        </details>
      </div>
    </div>
  )
}
